<template>
  <nav class="navbar navbar-expand-lg navbar-router">
    <ModalUser :showModal="showModal" :userEmail="userEmail" @close="closeModal" />
    <ModalValidation :showModal2="showModal2" @close="closeModal2" />
    <div class="logo">
      <router-link to="/home">
        <img src="@/assets/Cielum-logoaa.webp" alt="Logo" @click="goHome" />
      </router-link>
      <span class="logo__text" @click="goHome">Cielum PRM</span>
    </div>
    <div class="collapse navbar-collapse">
      <ul class="navbar-nav mr-auto">
        <li
          v-for="(item, index) in menuItems"
          :key="index"
          class="nav-item"
        >
          <RouterLink
            class="nav-link"
            :active-class="'active'"
            :to="item.path"
          >
            {{ item.name }}
          </RouterLink>
        </li>
      </ul>
      <div class="version">
      <span class="version__text" @click="toggleModal2()">V  {{ version }}</span>
    </div>
    </div>
    <div class="profile-dropdown">
      <div class="profile-icon" @click="toggleModal()">
        <svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" fill="white" class="bi bi-person-lines-fill" viewBox="0 0 16 16">
          <path d="M6 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6m-5 6s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1zM11 3.5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5m.5 2.5a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1zm2 3a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1zm0 3a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1z"/>
        </svg>
      </div>
      <h1 class="username">Usuario</h1>
    </div>
    <!-- Menú desplegable -->
  </nav>
</template>

<script setup>
import { ref, onMounted} from 'vue';
import { RouterLink,useRouter } from 'vue-router';
import ModalUser from './ModalUser.vue';
import ModalValidation from './ModalValidation.vue';

const menuItems = ref([])
const userEmail = ref('');
const showModal = ref(false);
const showModal2 = ref(false);
const router = useRouter();

const version = process.env.VUE_APP_VERSION_FRONT;
onMounted(() => {
  const storedMenuItems = localStorage.getItem("menuItems");
  if (storedMenuItems) {
    menuItems.value = JSON.parse(storedMenuItems);
  }

  const storedUserEmail = localStorage.getItem('username');
  if (storedUserEmail) {
    userEmail.value = storedUserEmail;
  }
});

const toggleModal = () => {
  showModal.value = true;
};

const toggleModal2 = () => {
  showModal2.value = true;
};

function closeModal() {
  showModal.value = false;
}

function closeModal2() {
  showModal2.value = false;
}

const goHome = () => {
  router.push('/home');
};
</script>

<style scoped>
.navbar-router {
  background-color: #8f73ff;
  display: flex-end;
  padding-right: 3%;
}

.username {
  font-size: 1em;
  color: #ffffff;
  margin-left: 15%;
  margin-bottom: 0.1rem;
  font-weight: 500;
}

.nav-link {
  color: white;
  border-radius: 6px;
}

.nav-link:hover {
  animation: rainbow 3s linear infinite;
  background-color: #fff;
  border-radius: 6px;
}

@keyframes rainbow {
  0% { color: #8f73ff; }
  10% { color: rgb(111, 0, 255); }
  20% { color: rgb(225, 0, 255); }
  30% { color: rgb(5, 238, 255); }
  40% { color: rgb(153, 0, 255); }
  50% { color: rgb(6, 141, 252); }
  60% { color: rgb(0, 113, 128); }
  70% { color: rgb(183, 0, 255); }
  80% { color: blue; }
  90% { color: rgb(2, 255, 200); }
  100% { color: violet; }
}

.logo {
  color: #fff;
  padding-inline: 10px;
  margin-left: 5px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-grow: 1;
}
.logo img {
  width: 50px;
  height: auto;
}

.SesionLogo {
  width: 50px;
  height: 50px;
}

.logo__text {
  font-size: 1.5rem;
  text-decoration: none;
  cursor: pointer;
  font-weight: 500;
  margin-left: 10px;
}
.active {
  background-color: #fff;
  color: black ;
  font-weight: 500;
}


.version {
  color: #fff;
  padding: 8px 10px;
  display: flex;
  border-radius: 5px;
  justify-content: flex-end;
  align-items:flex-end;
  margin-right: 2rem;
  margin-left: 5rem;
  transition: background-color 0.3s ease, color 0.3s ease, transform 0.2s ease;
}

.version:hover {
  background-color: #fff;
  border-radius: 0.25rem;
  transform: scale(1.05);
}


.version__text {
  transition: color 1s ease;
  text-decoration: none;
  cursor: pointer;
  font-weight: 500;
  
}
.version__text:hover {
  animation: rainbow 3s linear infinite;
}

@keyframes rainbow {
  0% { color: #8f73ff; }
  10% { color: rgb(111, 0, 255); }
  20% { color: rgb(225, 0, 255); }
  30% { color: rgb(5, 238, 255); }
  40% { color: rgb(153, 0, 255); }
  50% { color: rgb(6, 141, 252); }
  60% { color: rgb(0, 113, 128); }
  70% { color: rgb(183, 0, 255); }
  80% { color: blue; }
  90% { color: rgb(2, 255, 200); }
  100% { color: violet; }
}

.logout-container {
  margin-left: 3rem;
}

.btn-Exit {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 16px;
  background-color: #8f73ff;
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  cursor: pointer;
  transition: background-color 0.3s ease, color 0.3s ease, transform 0.2s ease;
}

.btn-Exit svg {
  fill: white;
  transition: fill 0.3s ease;
}

.btn-Exit:hover {
  background-color: #ffffff;
  color: black;
  transform: scale(1.05);
}

.btn-Exit:hover svg {
  fill: black;
}

.btn-Exit:active {
  transform: scale(0.95);
  background-color: #dddddd;
}

/* perfil */
.dropdown-menu-visible {
  position: absolute;
  top: 75px;
  right: 5px;
  background: #ffffff;
  border: 1px solid #e0e0e0;
  border-radius: 10px;
  box-shadow: 0px 10px 15px rgba(0, 0, 0, 0.1);
  width: 250px;
  z-index: 1000;
  padding: 15px;
  opacity: 1;
  transform: translateY(0);
  transition: opacity 0.3s ease, transform 0.3s ease;
  text-align: center;
}

/* Menú oculto */
.dropdown-menu-hidden {
  position: absolute;
  top: 60px;
  right: 0;
  width: 260px; 
  opacity: 0;
  transform: translateY(-20px);
  pointer-events: none;
  z-index: -1;
  transition: opacity 0.3s ease, transform 0.3s ease;
}


.profile-icon {
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 15px;
  margin-top: 1px;
  border-radius: 50%; 
  width: 50px; 
  height: 50px;
  background-color: #8f73ff; 
  transition: background-color 0.3s ease, transform 0.3s ease, box-shadow 0.3s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); 
}

.profile-icon:hover {
  transform: scale(1.1); 
  background-color: #8f73ff; 
  box-shadow: 0 6px 12px rgba(99, 0, 212, 0.493); 
  color: white; 
}

.profile-icon:active {
  transform: scale(1); 
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.2); 
}

.icon-container {
  margin-bottom: 10px;
}

.SesionLogo {
  width: 80px;
  height: auto;
  display: block;
  margin: 0 auto;
}

.user-email {
  font-size: 14px;
  color: #555;
  margin-bottom: 10px;
  font-weight: bold;
  white-space: nowrap; 
  overflow: hidden;
  text-overflow: ellipsis; 
}

.btn-exit {
  display: block;
  background: #8f73ff;
  color: #ffffff;
  border: none;
  border-radius: 8px;
  padding: 8px 10px;
  font-size: 14px;
  font-weight: bold;
  cursor: pointer;
  width: 100%;
  transition: background 0.3s ease;
}

.btn-exit:hover {
  background: #ff1f3a;
}

</style>
